module.exports = __webpack_public_path__ + "img/settings.f931af99.svg";